<template>
  <div>
    <van-empty image="error" :description="info" />
  </div>
</template>

<script>
import Vue from 'vue';

import {
  Empty
} from 'vant';
Vue.use(Empty);


export default {
  name: 'ErrorPage',
  props: {
    info: {
      type: String,
      default: ''
    }
  },
  computed: {

  },
  mounted () {

  },
  methods: {

  },
  data () {

  },
}
</script>

<style lang="less">
</style>